"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportBigInt = supportBigInt;
function supportBigInt() {
  return typeof BigInt === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./~/rc-input-number/lib/utils/supportUtil.js
// module id = 945
// module chunks = 0